
import React from 'react';
import { ShieldCheck, ChevronRight, Binary, Terminal, Database } from 'lucide-react';
import { SERVICES } from '../constants';

interface ServicesProps {
  onViewDetailed?: () => void;
}

const Services: React.FC<ServicesProps> = ({ onViewDetailed }) => {
  return (
    <section id="services" className="py-40 relative overflow-hidden scroll-mt-32">
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        
        <div className="flex flex-col md:flex-row justify-between items-end mb-24 gap-12">
          <div className="space-y-6">
            <h2 className="text-[11px] font-black text-brand-400 font-mono tracking-[0.5em] uppercase">CORE MODALITIES</h2>
            <h3 className="text-5xl md:text-7xl font-extrabold text-white leading-[0.9] tracking-tighter">
              Absolute Defense. <br /> Stellar Scale.
            </h3>
          </div>
          <p className="text-slate-400 max-w-sm font-light text-lg leading-relaxed">
            From deep-earth data vaults to orbital communication hubs, our protocols are the standard for high-integrity automation.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-10">
          {SERVICES.map((service, idx) => (
            <div 
              key={service.title} 
              className="glass-card group relative p-12 rounded-[3.5rem] flex flex-col h-full overflow-hidden"
            >
              <div className="hologram-line opacity-0 group-hover:opacity-100 transition-opacity" />
              <div className="absolute top-0 right-0 w-48 h-48 bg-brand-500/10 blur-[80px] opacity-0 group-hover:opacity-100 transition-opacity duration-1000" />
              
              <div className="w-20 h-20 rounded-3xl bg-brand-500/10 flex items-center justify-center mb-12 text-brand-400 group-hover:bg-brand-500 group-hover:text-black transition-all duration-700 border border-brand-500/20 group-hover:border-transparent group-hover:shadow-[0_0_40px_rgba(14,140,233,0.4)] relative">
                <div className="absolute inset-0 bg-brand-500/5 group-hover:animate-pulse" />
                {service.icon}
              </div>
              
              <h4 className="text-3xl font-black mb-6 tracking-tighter group-hover:text-brand-300 transition-colors">{service.title}</h4>
              <p className="text-slate-400 mb-12 text-[16px] leading-relaxed font-light">{service.description}</p>
              
              <div className="space-y-5 flex-grow">
                {service.features.map((feature) => (
                  <div key={feature} className="flex items-center gap-5 text-[12px] font-black text-slate-300 uppercase tracking-[0.1em]">
                    <div className="w-2 h-2 rounded-full bg-brand-500 shadow-[0_0_15px_rgba(14,140,233,1)]" />
                    {feature}
                  </div>
                ))}
              </div>

              <div className="mt-16 pt-10 border-t border-white/5">
                <button 
                  onClick={onViewDetailed}
                  className="group/btn flex items-center gap-3 text-[10px] font-black tracking-[0.4em] uppercase text-brand-400 hover:text-white transition-all"
                >
                  VIEW PROTOCOLS 
                  <ChevronRight className="w-4 h-4 group-hover/btn:translate-x-2 transition-transform" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
